export default "<button class=\"btn btn_save\" \n  (click)=\"onClick($event)\">\n   edit\n</button>";